import React from "react";
import {
  Card,
  CardStackSection,
  Stack,
  Text,
  Heading,
  Button,
} from "@origin-digital/ods-core";

interface EICFailurePageProps {
  onGoBack: () => void;
}

const EICFailurePage: React.FC<EICFailurePageProps> = ({ onGoBack }) => {
  return (
    <CardStackSection variant="card-centered">
      <Card padding="medium" stretchY>
        <Stack space={["large", "xlarge"]} alignX="center">
          <img
            src="https://www.originenergy.com.au/cdn/images/originenergy/image/upload/pictograms/pictogram_something-wrong.svg"
            alt="Something went wrong"
          />
          <Stack space={["medium", "large"]}>
            <Heading variant="h4" align="center">
              Sorry, something went wrong!
            </Heading>
            <Text align="center">
              Please try again later. Hopefully things will be back to normal by
              then.
            </Text>
          </Stack>
          <Button variant="outlined" onClick={onGoBack}>
            Go back
          </Button>
        </Stack>
      </Card>
    </CardStackSection>
  );
};

export default EICFailurePage;
